// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://backend.centerparcs-dev.smartrates.dynamica.engine.simon-kucher.com/api',
  Authority_URL: 'https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_GrcLItKjx',
  Client_ID: '588jdodv2clct7139p00vs1i21',
  project: "hospitality", // folder name
  name: 'Development'
};
